<template>
  <div class="wizard">
    <div class="main">
      <div class="first-step" v-if="step === 'first'">
        <p>{{ $t("integration.comeunity_step_1") }}</p>
      </div>

      <div class="second-step" v-if="step === 'second'">
        <p>{{ $t("integration.comeunity_step_2") }}</p>
      </div>
      <div class="second-step" v-if="step === 'success'">
        <p>{{ $t("integration.comeunity_step_success") }}</p>
      </div>
      <div class="second-step" v-if="step === 'fail'">
        <p>{{ $t("integration.comeunity_step_fail") }}</p>
      </div>
    </div>
    <div class="footer">
      <button
        :class="
          step === 'success' ? 'bttn bttn--lg bttn--blue el-right' : 'bttn bttn--lg bttn--blue'
        "
        @click.prevent="closeModal"
      >
        {{ $t("integration.close") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        v-if="step === 'first'"
        @click.prevent="nextStep('first')"
      >
        {{ $t("integration.next") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        v-if="step === 'second'"
        @click.prevent="nextStep('second')"
      >
        {{ $t("integration.next") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        v-if="step === 'fail'"
        @click.prevent="nextStep('first')"
      >
        {{ $t("integration.try_again") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import store from "@/store/store.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      redirectUri: "",
      comeunityIntegrationKey: "",
      client_id: "",
      step: "first",
      integrationStatus: false,
      currentIntegrationListCache: [],
      unsubscribe: "",
    };
  },

  computed: mapState({
    currentIntegrationList: (state) => {
      return state.integrations.integrations;
    },
  }),

  methods: {
    checkIntegrationList() {
      let orgId = localStorage.getItem("orgId");
      axios.get(urls.getIntegrationsList.replace(":orgId", orgId)).then((response) => {
        if (response.data.data.length > 0) {
          this.integrationStatus = true;
        }
      });
    },

    checkIntegration(mutation) {
      if (mutation.type === "setIntegrations") {
        const self = this;
        const newIntegration = mutation.payload.filter(function (o1) {
          return self.currentIntegrationListCache.every(function (o2) {
            return (
              o1.id != o2.id || (o1.id === o2.id && o1.attributes.status != o2.attributes.status)
            );
          });
        });

        if (newIntegration.length > 0 && newIntegration[0].attributes.status === 1) {
          this.step = "success";
        } else {
          this.step = "fail";
        }
      }
      this.unsubscribe();
    },

    getComeunityIntegrationKey() {
      let orgId = localStorage.getItem("orgId");
      return axios
        .post(urls.getCommunityIntegrationKey.replace(":orgId", orgId), null, {
          params: {},
        })
        .then((response) => {
          this.redirectUri = response.data.callback_url;
          this.client_id = response.data.client_id;
          this.comeunityIntegrationKey = response.data.comeunity_integration_key;
          document.cookie =
            "comeunity_integration_key=" +
            response.data.comeunity_integration_key +
            ";domain=.charidy.com;path=/";
        });
    },

    nextStep(step) {
      if (step === "first") {
        this.getComeunityIntegrationKey().then(() => {
          this.step = "second";

          let host = "accounts.zohoportal.com";
          window.open(
            `https://${host}/clientoauth/v2/10023122998/auth?response_type=code&client_id=${this.client_id}&redirect_uri=${this.redirectUri}&state=${this.comeunityIntegrationKey}&scope=ZohoCRM.modules.ALL,ZohoCRM.settings.ALL,ZohoCRM.users.ALL,ZohoCRM.org.ALL,ZohoSearch.securesearch.READ&access_type=offline&prompt=consent`,
            "_blank"
          );
        });
      }
      if (step === "second") {
        this.currentIntegrationListCache = this.currentIntegrationList;
        store.dispatch("getIntegrationsList");
        this.unsubscribe = store.subscribe((mutation, state) => {
          this.checkIntegration(mutation, state);
        });
      }
    },

    closeModal() {
      this.$store.dispatch("getIntegrationsList");
      this.$emit("close-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
}
.el-right {
  margin-left: auto;
}
.account-link {
  font-size: 16px;
  color: #cc6d4c;
}
</style>
